import { getApp, getApps, initializeApp } from 'firebase/app'
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth'
import { ref as dbRef, getDatabase } from 'firebase/database'
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage'

import { env } from '@/config/env'

export const app = getApps().length > 0 ? getApp() : initializeApp(env.firebaseConfig)

export const firebaseAuth = getAuth(app)

if (typeof window !== 'undefined') {
  setPersistence(firebaseAuth, browserLocalPersistence)
}

export const getStorageDownloadUrl = async (path: string) => {
  const downloadUrl = await getDownloadURL(ref(getStorage(), path))

  return downloadUrl
}

export const uploadToStorage = (path: string, file: File) => {
  return uploadBytes(ref(getStorage(), path), file)
}

export const getRealtimeRef = (path: string) => {
  return dbRef(getDatabase(undefined, env.firebaseRTDBUrl), path)
}
